export default "__VITE_ASSET__bb96adf6__"